/* ==========================================================================
   LC FUEL CALCULATOR
   Soma carbo / sódio / cafeína / água conforme o atleta clica nos produtos
   que pretende consumir, e gera um PNG com o resumo (fuel by pace it).
   ========================================================================== */

(function () {
  'use strict';

  var LOGO_URL = 'https://loja.paceit.com.br/cdn/shop/files/72_adefb222-5e32-48b7-a280-ca8f85502cb1.svg?v=1755885172';

  function init(root) {
    var counts = {};
    var outros = []; // { cho, na, caf, id }
    var outrosSeq = 0;

    var products = Array.prototype.slice.call(root.querySelectorAll('[data-lcf-product]'));
    var outrosForm = root.querySelector('[data-lcf-outros-form]');
    var outrosList = root.querySelector('[data-lcf-outros-list]');

    var summaryCho = root.querySelector('[data-lcf-total="cho"]');
    var summaryNa = root.querySelector('[data-lcf-total="na"]');
    var summaryCaf = root.querySelector('[data-lcf-total="caf"]');
    var summaryWater = root.querySelector('[data-lcf-total="water"]');
    var nitratoItem = root.querySelector('[data-lcf-total-item="nitrato"]');
    var summaryNitrato = root.querySelector('[data-lcf-total="nitrato"]');

    var perHourCho = root.querySelector('[data-lcf-perhour="cho"]');
    var perHourNa = root.querySelector('[data-lcf-perhour="na"]');
    var perHourCaf = root.querySelector('[data-lcf-perhour="caf"]');
    var perHourWater = root.querySelector('[data-lcf-perhour="water"]');
    var perHourNitrato = root.querySelector('[data-lcf-perhour="nitrato"]');

    var unidadeBar = root.querySelector('[data-lcf-unidade]');
    var unidadeBtns = unidadeBar ? Array.prototype.slice.call(unidadeBar.querySelectorAll('[data-lcf-unidade-btn]')) : [];
    var unidadeValue = 'km';
    var UNIT_STEP = { km: 1, min: 5 };
    var scheduleCard = root.querySelector('[data-lcf-schedule-card]');
    var scheduleList = root.querySelector('[data-lcf-schedule-list]');
    var scheduleRows = {};

    var modalidadeField = root.querySelector('[data-lcf-field="modalidade"]');
    var modalidadeSelect = root.querySelector('[data-lcf-modalidade]');
    var modalidadeOutro = root.querySelector('[data-lcf-modalidade-outro]');
    var distanciaInput = root.querySelector('[data-lcf-distancia]');
    var horaInput = root.querySelector('[data-lcf-h]');
    var minInput = root.querySelector('[data-lcf-m]');
    var segInput = root.querySelector('[data-lcf-s]');

    var resetBtn = root.querySelector('[data-lcf-reset]');
    var uploadFotoBtns = Array.prototype.slice.call(root.querySelectorAll('[data-lcf-upload-foto]'));
    var fotoInput = root.querySelector('[data-lcf-foto-input]');

    function currentUnit() {
      return unidadeValue;
    }

    function currentStep() {
      return UNIT_STEP[unidadeValue] || 1;
    }

    function refreshScheduleVisibility() {
      var total = 0;
      Object.keys(scheduleRows).forEach(function (k) { total += scheduleRows[k].length; });
      if (scheduleCard) scheduleCard.style.display = total > 0 ? '' : 'none';
    }

    function addScheduleRow(key, productName, productImg, onRemoveClick) {
      var row = document.createElement('div');
      row.className = 'lc-fuel__schedule-row';

      var name = document.createElement('span');
      name.className = 'lc-fuel__schedule-name';
      name.textContent = productName;
      row.appendChild(name);

      var isRedroot = key === 'redroot';
      var timing = 'pre';

      var inputWrap = document.createElement('div');
      inputWrap.className = 'lc-fuel__schedule-input';

      var input = document.createElement('input');
      input.type = 'number';
      input.min = '0';
      input.step = String(currentStep());
      input.placeholder = '0';
      input.setAttribute('data-lcf-schedule-moment', '');
      inputWrap.appendChild(input);

      var unitSpan = document.createElement('span');
      unitSpan.setAttribute('data-lcf-schedule-unit', '');
      unitSpan.textContent = currentUnit();
      inputWrap.appendChild(unitSpan);

      if (isRedroot) {
        var timingBar = document.createElement('div');
        timingBar.className = 'lc-fuel__schedule-timing';

        var preBtn = document.createElement('button');
        preBtn.type = 'button';
        preBtn.className = 'lc-fuel__schedule-timing-btn is-active';
        preBtn.textContent = 'Pré-treino';

        var intraBtn = document.createElement('button');
        intraBtn.type = 'button';
        intraBtn.className = 'lc-fuel__schedule-timing-btn';
        intraBtn.textContent = 'Intra';

        timingBar.appendChild(preBtn);
        timingBar.appendChild(intraBtn);
        row.appendChild(timingBar);

        inputWrap.style.display = 'none';

        preBtn.addEventListener('click', function () {
          if (timing === 'pre') return;
          timing = 'pre';
          row._lcfTiming = timing;
          preBtn.classList.add('is-active');
          intraBtn.classList.remove('is-active');
          inputWrap.style.display = 'none';
        });

        intraBtn.addEventListener('click', function () {
          if (timing === 'intra') return;
          timing = 'intra';
          row._lcfTiming = timing;
          intraBtn.classList.add('is-active');
          preBtn.classList.remove('is-active');
          inputWrap.style.display = '';
        });
      }

      row.appendChild(inputWrap);

      var removeBtn = document.createElement('button');
      removeBtn.type = 'button';
      removeBtn.className = 'lc-fuel__schedule-remove';
      removeBtn.setAttribute('aria-label', 'Remover dose');
      removeBtn.textContent = '×';
      removeBtn.addEventListener('click', function () {
        onRemoveClick(row);
      });
      row.appendChild(removeBtn);

      row._lcfInput = input;
      row._lcfProductName = productName;
      row._lcfProductImg = productImg;
      row._lcfTiming = isRedroot ? timing : null;

      scheduleList.appendChild(row);
      scheduleRows[key].push(row);
      refreshScheduleVisibility();
    }

    function removeSpecificRow(key, row) {
      scheduleRows[key] = scheduleRows[key].filter(function (r) { return r !== row; });
      if (row.parentNode) row.parentNode.removeChild(row);
      refreshScheduleVisibility();
    }

    function removeLastRow(key) {
      var rows = scheduleRows[key];
      var row = rows.pop();
      if (row && row.parentNode) row.parentNode.removeChild(row);
      refreshScheduleVisibility();
    }

    function getScheduleEntries() {
      var entries = [];
      var unit = currentUnit();
      Object.keys(scheduleRows).forEach(function (key) {
        scheduleRows[key].forEach(function (row) {
          var raw = parseFloat(row._lcfInput.value);
          entries.push({
            moment: isNaN(raw) ? null : raw,
            unit: unit,
            name: row._lcfProductName,
            img: row._lcfProductImg || null,
            timing: row._lcfTiming || null
          });
        });
      });
      entries.sort(function (a, b) {
        var av = a.timing === 'pre' ? -1 : (a.moment === null ? Infinity : a.moment);
        var bv = b.timing === 'pre' ? -1 : (b.moment === null ? Infinity : b.moment);
        return av - bv;
      });
      return entries;
    }

    if (unidadeBtns.length) {
      unidadeBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var u = btn.getAttribute('data-lcf-unidade-btn');
          if (u === unidadeValue) return;
          unidadeValue = u;

          unidadeBtns.forEach(function (b) {
            var active = b === btn;
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', active ? 'true' : 'false');
          });

          Array.prototype.slice.call(root.querySelectorAll('[data-lcf-schedule-unit]')).forEach(function (el) {
            el.textContent = u;
          });
          Array.prototype.slice.call(root.querySelectorAll('[data-lcf-schedule-moment]')).forEach(function (el) {
            el.step = String(currentStep());
          });
        });
      });
    }

    products.forEach(function (card) {
      var key = card.dataset.lcfProduct;
      counts[key] = 0;
      scheduleRows[key] = [];
      var isTimed = key !== 'agua';
      var minus = card.querySelector('[data-lcf-minus]');
      var plus = card.querySelector('[data-lcf-plus]');
      var countEl = card.querySelector('[data-lcf-count]');
      var nameEl = card.querySelector('.lc-fuel__product-name');
      var productName = nameEl ? nameEl.textContent : key;
      var imgEl = card.querySelector('.lc-fuel__product-img');
      var productImg = imgEl ? imgEl.src : null;

      function render() {
        countEl.textContent = counts[key];
        card.setAttribute('data-count', counts[key]);
      }

      plus.addEventListener('click', function () {
        counts[key]++;
        render();
        if (isTimed) {
          addScheduleRow(key, productName, productImg, function (row) {
            if (counts[key] > 0) counts[key]--;
            render();
            removeSpecificRow(key, row);
            updateTotals();
          });
        }
        updateTotals();
      });

      minus.addEventListener('click', function () {
        if (counts[key] > 0) {
          counts[key]--;
          render();
          if (isTimed) removeLastRow(key);
          updateTotals();
        }
      });

      render();
    });

    if (modalidadeSelect && modalidadeField) {
      modalidadeSelect.addEventListener('change', function () {
        var isOutro = modalidadeSelect.value === 'Outro';
        modalidadeField.setAttribute('data-modalidade-outro', isOutro ? 'active' : '');
      });
    }

    if (outrosForm) {
      outrosForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var choInput = outrosForm.querySelector('[name="outro-cho"]');
        var naInput = outrosForm.querySelector('[name="outro-na"]');
        var cafInput = outrosForm.querySelector('[name="outro-caf"]');
        var nitratoInput = outrosForm.querySelector('[name="outro-nitrato"]');

        var cho = parseFloat(choInput.value) || 0;
        var na = parseFloat(naInput.value) || 0;
        var caf = parseFloat(cafInput.value) || 0;
        var nitrato = nitratoInput ? (parseFloat(nitratoInput.value) || 0) : 0;

        if (cho <= 0 && na <= 0 && caf <= 0 && nitrato <= 0) return;

        var entry = { id: ++outrosSeq, cho: cho, na: na, caf: caf, nitrato: nitrato };
        outros.push(entry);
        renderOutrosList();
        updateTotals();

        choInput.value = '';
        naInput.value = '';
        cafInput.value = '';
        if (nitratoInput) nitratoInput.value = '';
        choInput.focus();
      });
    }

    function renderOutrosList() {
      if (!outrosList) return;
      outrosList.innerHTML = '';
      outros.forEach(function (entry) {
        var chip = document.createElement('span');
        chip.className = 'lc-fuel__outros-chip';

        var parts = [];
        if (entry.cho) parts.push(entry.cho + 'g carbo');
        if (entry.na) parts.push(entry.na + 'mg sódio');
        if (entry.caf) parts.push(entry.caf + 'mg cafeína');
        if (entry.nitrato) parts.push(entry.nitrato + 'mg nitrato');

        var label = document.createElement('span');
        label.textContent = parts.join(' · ');
        chip.appendChild(label);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.setAttribute('aria-label', 'Remover');
        removeBtn.textContent = '×';
        removeBtn.addEventListener('click', function () {
          outros = outros.filter(function (o) { return o.id !== entry.id; });
          renderOutrosList();
          updateTotals();
        });
        chip.appendChild(removeBtn);

        outrosList.appendChild(chip);
      });
    }

    function computeTotals() {
      var totals = { cho: 0, na: 0, caf: 0, water: 0, nitrato: 0 };

      products.forEach(function (card) {
        var qty = counts[card.dataset.lcfProduct];
        if (!qty) return;
        totals.cho += qty * (parseFloat(card.dataset.lcfCho) || 0);
        totals.na += qty * (parseFloat(card.dataset.lcfNa) || 0);
        totals.caf += qty * (parseFloat(card.dataset.lcfCaf) || 0);
        totals.water += qty * (parseFloat(card.dataset.lcfWater) || 0);
        totals.nitrato += qty * (parseFloat(card.dataset.lcfNitrato) || 0);
      });

      outros.forEach(function (entry) {
        totals.cho += entry.cho;
        totals.na += entry.na;
        totals.caf += entry.caf;
        totals.nitrato += entry.nitrato || 0;
      });

      return totals;
    }

    function round(n) {
      return Math.round(n * 10) / 10;
    }

    function getTotalHours() {
      var h = horaInput ? (parseFloat(horaInput.value) || 0) : 0;
      var m = minInput ? (parseFloat(minInput.value) || 0) : 0;
      var s = segInput ? (parseFloat(segInput.value) || 0) : 0;
      return h + m / 60 + s / 3600;
    }

    function setPerHour(el, total, hours, unit) {
      if (!el) return;
      if (hours > 0) {
        el.textContent = round(total / hours) + unit + '/h';
        el.style.display = '';
      } else {
        el.style.display = 'none';
      }
    }

    function updateTotals() {
      var totals = computeTotals();
      var hours = getTotalHours();

      if (summaryCho) summaryCho.textContent = round(totals.cho) + 'g';
      if (summaryNa) summaryNa.textContent = Math.round(totals.na) + 'mg';
      if (summaryCaf) summaryCaf.textContent = Math.round(totals.caf) + 'mg';
      if (summaryWater) summaryWater.textContent = Math.round(totals.water) + 'ml';

      setPerHour(perHourCho, totals.cho, hours, 'g');
      setPerHour(perHourNa, totals.na, hours, 'mg');
      setPerHour(perHourCaf, totals.caf, hours, 'mg');
      setPerHour(perHourWater, totals.water, hours, 'ml');

      if (nitratoItem && summaryNitrato) {
        if (totals.nitrato > 0) {
          nitratoItem.style.display = '';
          summaryNitrato.textContent = Math.round(totals.nitrato) + 'mg';
          setPerHour(perHourNitrato, totals.nitrato, hours, 'mg');
        } else {
          nitratoItem.style.display = 'none';
        }
      }
    }

    if (horaInput) horaInput.addEventListener('input', updateTotals);
    if (minInput) minInput.addEventListener('input', updateTotals);
    if (segInput) segInput.addEventListener('input', updateTotals);

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        products.forEach(function (card) { counts[card.dataset.lcfProduct] = 0; });
        outros = [];
        renderOutrosList();
        products.forEach(function (card) {
          var countEl = card.querySelector('[data-lcf-count]');
          countEl.textContent = '0';
          card.setAttribute('data-count', '0');
        });
        Object.keys(scheduleRows).forEach(function (k) { scheduleRows[k] = []; });
        if (scheduleList) scheduleList.innerHTML = '';
        if (scheduleCard) scheduleCard.style.display = 'none';
        if (distanciaInput) distanciaInput.value = '';
        if (horaInput) horaInput.value = '';
        if (minInput) minInput.value = '';
        if (segInput) segInput.value = '';
        updateTotals();
      });
    }

    function buildPayload() {
      var totals = computeTotals();
      var modalidade = modalidadeSelect ? modalidadeSelect.value : '';
      if (modalidade === 'Outro' && modalidadeOutro && modalidadeOutro.value) {
        modalidade = modalidadeOutro.value;
      }
      var distancia = distanciaInput ? distanciaInput.value : '';
      var h = horaInput ? (horaInput.value || '0') : '0';
      var m = minInput ? (minInput.value || '0') : '0';
      var s = segInput ? (segInput.value || '0') : '0';

      return {
        modalidade: modalidade,
        distancia: distancia,
        tempo: pad(h) + ':' + pad(m) + ':' + pad(s),
        totals: totals,
        hours: getTotalHours(),
        schedule: getScheduleEntries(),
        logoUrl: root.getAttribute('data-lcf-logo') || LOGO_URL
      };
    }

    function fileSafeName(modalidade) {
      return (modalidade || 'treino').toLowerCase().replace(/[^a-z0-9]+/g, '-');
    }

    if (uploadFotoBtns.length && fotoInput) {
      var pendingUploadBtn = null;

      uploadFotoBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          pendingUploadBtn = btn;
          fotoInput.click();
        });
      });

      fotoInput.addEventListener('change', function () {
        var file = fotoInput.files && fotoInput.files[0];
        var btn = pendingUploadBtn;
        if (!file || !btn) return;

        var mode = btn.getAttribute('data-lcf-upload-foto');

        btn.disabled = true;
        var originalText = btn.textContent;
        btn.textContent = 'Gerando...';

        var reader = new FileReader();
        reader.onload = function () {
          var photo = new Image();
          photo.onload = function () {
            var payload = buildPayload();
            var photoCanvas = document.createElement('canvas');
            photoCanvas.width = photo.naturalWidth;
            photoCanvas.height = photo.naturalHeight;
            var pctx = photoCanvas.getContext('2d');
            pctx.drawImage(photo, 0, 0, photoCanvas.width, photoCanvas.height);

            var margin = photoCanvas.width * 0.06;

            function finishUpload() {
              downloadCanvas(photoCanvas, 'fuel-by-pace-it-foto-' + mode + '-' + fileSafeName(payload.modalidade));
              btn.disabled = false;
              btn.textContent = originalText;
              fotoInput.value = '';
            }

            // faixa de estatísticas: cola na base da foto, sempre do mesmo
            // jeito (padrão), não importa o botão/modo usado pro upload.
            // sem overlay do plano de consumo no topo.
            function drawBottomOverlay(frameCanvas) {
              var targetW = photoCanvas.width - margin * 2;
              var scale = targetW / frameCanvas.width;
              var targetH = frameCanvas.height * scale;
              pctx.drawImage(frameCanvas, margin, photoCanvas.height - targetH - margin, targetW, targetH);
            }

            buildFrame(payload, 'banner', function (bannerCanvas) {
              drawBottomOverlay(bannerCanvas);
              finishUpload();
            });
          };
          photo.onerror = function () {
            btn.disabled = false;
            btn.textContent = originalText;
            fotoInput.value = '';
          };
          photo.src = reader.result;
        };
        reader.readAsDataURL(file);
      });
    }

    function pad(v) {
      v = String(v);
      return v.length < 2 ? '0' + v : v;
    }

    updateTotals();
  }

  function downloadCanvas(canvas, filenameBase) {
    canvas.toBlob(function (blob) {
      var url = URL.createObjectURL(blob);
      var a = document.createElement('a');
      a.href = url;
      a.download = filenameBase + '.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(function () { URL.revokeObjectURL(url); }, 2000);
    }, 'image/png');
  }

  // shape: 'card' (totais — marca no topo + plano de consumo + estatísticas,
  // tudo num canvas vertical só), 'banner' (moldura — faixa horizontal de
  // estatísticas com ícones vetoriais + marca inline, sem plano de consumo,
  // pensada pra colar embaixo de uma foto) ou 'timeline' (overlay isolado só
  // com o plano de consumo horizontal, sem marca/estatísticas, pensado pra
  // colar no topo da foto quando "moldura" tem plano de consumo — usado junto
  // com uma chamada separada em 'banner' pra faixa de estatísticas embaixo).
  function buildFrame(data, shape, callback) {
    var PAD = 48;
    var PILL_COLOR = '#15202D';
    var hours = data.hours || 0;

    // padrão: texto solto, sem pílulas/fundo atrás de cada elemento — o PNG
    // final fica transparente, só com o texto branco (serve pra "totais",
    // "moldura" e "timeline"). "card" e "timeline" mostram o plano de
    // consumo; "banner" não.
    var pills = false;
    var isCard = shape === 'card';
    var isBanner = shape === 'banner';
    var isTimeline = shape === 'timeline';
    var schedule = (isCard || isTimeline) ? (data.schedule || []) : [];
    var hasSchedule = schedule.length > 0;

    function round1(n) {
      return Math.round(n * 10) / 10;
    }

    function perHourText(total, unit) {
      if (hours <= 0) return null;
      return round1(total / hours) + unit + '/h';
    }

    var items = [
      { key: 'cho', icon: '🌾', label: 'CARBOIDRATO', value: round1(data.totals.cho) + 'g', perHour: perHourText(data.totals.cho, 'g') },
      { key: 'na', icon: '🧂', label: 'SÓDIO', value: Math.round(data.totals.na) + 'mg', perHour: perHourText(data.totals.na, 'mg') },
      { key: 'caf', icon: '⚡', label: 'CAFEÍNA', value: Math.round(data.totals.caf) + 'mg', perHour: perHourText(data.totals.caf, 'mg') },
      { key: 'water', icon: '💧', label: 'ÁGUA', value: Math.round(data.totals.water) + 'ml', perHour: perHourText(data.totals.water, 'ml') }
    ];
    if (data.totals.nitrato > 0) {
      items.push({ key: 'nitrato', icon: '⬡', label: 'NITRATO', value: Math.round(data.totals.nitrato) + 'mg', perHour: perHourText(data.totals.nitrato, 'mg') });
    }

    // --- medição de texto (usa um canvas descartável só pra ter um ctx antes
    // de sabermos a altura final do card) ---
    var measureCanvas = document.createElement('canvas');
    var mctx = measureCanvas.getContext('2d');

    function badgeSize(lines, font, padX, padY, lineGap) {
      mctx.font = font;
      var maxW = 0;
      lines.forEach(function (l) { maxW = Math.max(maxW, mctx.measureText(l).width); });
      var fontSize = parseFloat(/([\d.]+)px/.exec(font)[1]);
      var lineH = fontSize * 1.22;
      var textH = lines.length * lineH + Math.max(0, lines.length - 1) * lineGap;
      return { w: maxW + padX * 2, h: textH + padY * 2, lineH: lineH };
    }

    var VALUE_FONT = pills ? '800 26px sans-serif' : '700 30px sans-serif';
    var LABEL_FONT = pills ? '800 12px sans-serif' : '700 13px sans-serif';
    var PERHOUR_FONT = pills ? '700 11px sans-serif' : '500 12px sans-serif';
    var FUELED_FONT = pills ? '800 12px sans-serif' : '700 13px sans-serif';

    function measureW(font, text) {
      mctx.font = font;
      return mctx.measureText(text).width;
    }

    var canvas, ctx;

    var CARD_W, TOTAL_H, PAD_TOP, BRAND_HEADER_H, GAP_BRAND_NEXT, GAP_TIMELINE_STATS,
      timelineBlockH, brandCenterX, statsColW;

    // ===================== layout: PLANO DE CONSUMO (linha do tempo horizontal) =====================
    // header + uma linha de rótulos (momentos) + uma única linha horizontal
    // com pontos, uma marquinha vertical descendo até um card quadrado
    // colorido (cor cicla por uma paleta) com a fotinho do produto em
    // "contain" (sem corte, pode vazar as bordas do card). Compartilhado
    // entre o shape "card" (embutido no card vertical) e "timeline" (overlay
    // isolado, sem marca/estatísticas).
    var HEADER_FONT = '800 24px sans-serif';
    var MOMENT_FONT = '700 15px sans-serif';
    var TIMELINE_HEADER_H = 34;
    var TIMELINE_HEADER_GAP = 18;
    var TIMELINE_LABEL_H = 20;
    var TIMELINE_LABEL_GAP = 14;
    var TIMELINE_DOT_D = 14;
    var TIMELINE_TICK_H = 12;
    var TIMELINE_CARD_SIZE = 76;
    var TIMELINE_CARD_GAP = 28;
    var TIMELINE_PAD_BOTTOM = 36;
    var TIMELINE_PALETTE = ['#e6436b', '#c58a5c', '#86cfe6', '#8d7fe0', '#6fbf8b'];

    var timelineRows = [];
    if (hasSchedule) {
      timelineRows = schedule.map(function (entry, i) {
        var momentText = entry.timing === 'pre'
          ? 'PRÉ-TREINO'
          : (entry.moment === null ? '—' : (round1(entry.moment) + ' ' + entry.unit));
        var labelW = measureW(MOMENT_FONT, momentText);
        var colW = Math.max(TIMELINE_CARD_SIZE, labelW);
        return {
          momentText: momentText, img: entry.img,
          color: TIMELINE_PALETTE[i % TIMELINE_PALETTE.length],
          colW: colW
        };
      });
    }

    var timelineColW = timelineRows.reduce(function (max, r) { return Math.max(max, r.colW); }, 0) + TIMELINE_CARD_GAP;
    var timelineMinW = PAD * 2 + timelineColW * timelineRows.length;
    timelineBlockH = hasSchedule
      ? (TIMELINE_HEADER_H + TIMELINE_HEADER_GAP + TIMELINE_LABEL_H + TIMELINE_LABEL_GAP +
        TIMELINE_DOT_D + TIMELINE_TICK_H + TIMELINE_CARD_SIZE + TIMELINE_PAD_BOTTOM)
      : 0;

    if (isCard) {
      // ===================== layout: estatísticas + marca =====================
      // a largura de cada coluna de estatística é calculada a partir do próprio
      // conteúdo (valor/label/perHour mais largos), e não mais uma divisão fixa
      // do card — isso evita números se sobrepondo quando há muitos itens
      // (ex.: com nitrato, 5 colunas) ou valores com muitos dígitos.
      var STATS_ROW_H = 120;
      var STAT_COL_MIN_W = 80;
      var STAT_COL_PAD = 24;

      statsColW = STAT_COL_MIN_W;
      items.forEach(function (item) {
        var w = measureW(VALUE_FONT, item.value);
        w = Math.max(w, measureW(LABEL_FONT, item.label));
        if (item.perHour) w = Math.max(w, measureW(PERHOUR_FONT, item.perHour));
        statsColW = Math.max(statsColW, w + STAT_COL_PAD);
      });

      var statsAreaW = statsColW * items.length;
      CARD_W = PAD * 2 + statsAreaW;
      if (hasSchedule) CARD_W = Math.max(CARD_W, timelineMinW);

      // estatísticas sempre esticam pra ocupar a largura final do card
      // (seja ela ditada pelas próprias estatísticas, seja pela linha do tempo)
      statsColW = (CARD_W - PAD * 2) / items.length;

      // ===================== layout: marca (no topo) =====================
      var BRAND_GAP = 10;
      var BRAND_LOGO_H = 30;
      var fbH = 18;
      BRAND_HEADER_H = fbH + BRAND_GAP + BRAND_LOGO_H;
      brandCenterX = CARD_W / 2;

      PAD_TOP = 36;
      GAP_BRAND_NEXT = 30;
      GAP_TIMELINE_STATS = hasSchedule ? 20 : 0;
      var PAD_BOTTOM = 40;

      TOTAL_H = PAD_TOP + BRAND_HEADER_H + GAP_BRAND_NEXT + timelineBlockH + GAP_TIMELINE_STATS + STATS_ROW_H + PAD_BOTTOM;

      canvas = document.createElement('canvas');
      canvas.width = CARD_W;
      canvas.height = TOTAL_H;
      ctx = canvas.getContext('2d');
      // fundo do canvas fica transparente de propósito: o texto fica solto em
      // branco, sem nenhum fundo, pra colar em cima de qualquer foto.
    } else if (isTimeline) {
      // ===================== layout: linha do tempo isolada =====================
      // overlay independente (sem marca, sem estatísticas) pra colar no topo
      // da foto quando "moldura" tem plano de consumo — a faixa de
      // estatísticas continua indo embaixo, via uma chamada separada com
      // shape "banner".
      CARD_W = timelineMinW;
      PAD_TOP = 0;
      TOTAL_H = timelineBlockH;

      canvas = document.createElement('canvas');
      canvas.width = CARD_W;
      canvas.height = TOTAL_H;
      ctx = canvas.getContext('2d');
    }

    function roundRect(x, y, w, h, r) {
      ctx.beginPath();
      ctx.moveTo(x + r, y);
      ctx.arcTo(x + w, y, x + w, y + h, r);
      ctx.arcTo(x + w, y + h, x, y + h, r);
      ctx.arcTo(x, y + h, x, y, r);
      ctx.arcTo(x, y, x + w, y, r);
      ctx.closePath();
    }

    function drawPill(x, y, w, h) {
      ctx.fillStyle = PILL_COLOR;
      roundRect(x, y, w, h, h / 2);
      ctx.fill();
    }

    // desenha (opcionalmente) uma pílula atrás de uma ou mais linhas de texto.
    // retorna a altura total ocupada (badge.h), pra quem chamou encadear o layout.
    function drawTextBlock(x, y, lines, font, color, align, badge, padX, padY, lineGap) {
      var w = badge ? badge.w : null;
      var rectX = x;
      if (badge) {
        rectX = align === 'center' ? x - badge.w / 2 : x;
        drawPill(rectX, y, badge.w, badge.h);
      }
      ctx.textAlign = 'center';
      ctx.font = font;
      ctx.fillStyle = color;
      var cx = badge ? (rectX + badge.w / 2) : x;
      var lineH = badge ? badge.lineH : parseFloat(/([\d.]+)px/.exec(font)[1]) * 1.22;
      lines.forEach(function (line, i) {
        var baseline = y + padY + lineH * (i + 1) - lineH * 0.28 + i * lineGap;
        ctx.fillText(line, cx, baseline);
      });
      ctx.textAlign = 'left';
      return badge ? badge.h : (lines.length * lineH + Math.max(0, lines.length - 1) * lineGap);
    }

    // desenha o card quadrado colorido + a fotinho do produto em "contain"
    // (sem corte, preserva proporção, pode vazar um pouco das bordas do card).
    function drawTimelineCard(cx, topY, imgUrl, color) {
      var x = cx - TIMELINE_CARD_SIZE / 2;
      ctx.fillStyle = color;
      roundRect(x, topY, TIMELINE_CARD_SIZE, TIMELINE_CARD_SIZE, 16);
      ctx.fill();

      var imgEl = imgUrl ? scheduleImages[imgUrl] : null;
      if (!imgEl) return;
      var overflow = TIMELINE_CARD_SIZE * 1.3;
      var scale = Math.min(overflow / imgEl.naturalWidth, overflow / imgEl.naturalHeight);
      var dw = imgEl.naturalWidth * scale;
      var dh = imgEl.naturalHeight * scale;
      ctx.drawImage(imgEl, cx - dw / 2, topY + TIMELINE_CARD_SIZE / 2 - dh / 2, dw, dh);
    }

    function drawTimeline(top) {
      ctx.textAlign = 'left';
      ctx.fillStyle = '#ffffff';
      ctx.font = HEADER_FONT;
      ctx.fillText('PLANO DE CONSUMO', PAD, top + 24);

      var n = timelineRows.length;
      if (n === 0) return;
      var colW = (CARD_W - PAD * 2) / n;

      var labelBaselineY = top + TIMELINE_HEADER_H + TIMELINE_HEADER_GAP + TIMELINE_LABEL_H - 4;
      var lineY = top + TIMELINE_HEADER_H + TIMELINE_HEADER_GAP + TIMELINE_LABEL_H + TIMELINE_LABEL_GAP + TIMELINE_DOT_D / 2;
      var cardTopY = lineY + TIMELINE_DOT_D / 2 + TIMELINE_TICK_H;

      // linha horizontal conectando todos os pontos
      ctx.strokeStyle = 'rgba(255,255,255,.25)';
      ctx.lineWidth = 2;
      ctx.beginPath();
      ctx.moveTo(PAD + colW / 2, lineY);
      ctx.lineTo(PAD + colW * (n - 0.5), lineY);
      ctx.stroke();

      timelineRows.forEach(function (row, i) {
        var cx = PAD + colW * i + colW / 2;

        ctx.textAlign = 'center';
        ctx.font = MOMENT_FONT;
        ctx.fillStyle = 'rgba(255,255,255,.85)';
        ctx.fillText(row.momentText, cx, labelBaselineY);

        ctx.fillStyle = '#ffffff';
        ctx.beginPath();
        ctx.arc(cx, lineY, TIMELINE_DOT_D / 2, 0, Math.PI * 2);
        ctx.fill();

        ctx.strokeStyle = 'rgba(255,255,255,.25)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(cx, lineY + TIMELINE_DOT_D / 2);
        ctx.lineTo(cx, cardTopY);
        ctx.stroke();

        drawTimelineCard(cx, cardTopY, row.img, row.color);
      });

      ctx.textAlign = 'left';
    }

    function drawBrandHeader(top, logoTmp) {
      ctx.textAlign = 'center';
      ctx.fillStyle = pills ? '#ffffff' : 'rgba(255,255,255,.55)';
      ctx.font = FUELED_FONT;

      if (pills) {
        drawTextBlock(brandCenterX, top, ['FUELED BY'], FUELED_FONT, '#ffffff', 'center', fbBadge, 14, 8, 0);
      } else {
        ctx.fillText('FUELED BY', brandCenterX, top + fbH);
      }

      if (logoTmp) {
        var logoW = (logoTmp.width / logoTmp.height) * BRAND_LOGO_H;
        var logoY = top + fbH + BRAND_GAP;
        ctx.drawImage(logoTmp, brandCenterX - logoW / 2, logoY, logoW, BRAND_LOGO_H);
      }
      ctx.textAlign = 'left';
    }

    function drawStatsRow(top) {
      items.forEach(function (item, i) {
        var cx = PAD + statsColW * i + statsColW / 2;
        ctx.textAlign = 'center';

        ctx.font = '32px sans-serif';
        ctx.fillStyle = '#ffffff';
        ctx.fillText(item.icon, cx, top + 34);

        var cursor = top + 44;
        if (pills) {
          var valueBadge = badgeSize([item.value], VALUE_FONT, 14, 8, 0);
          var vH = drawTextBlock(cx, cursor, [item.value], VALUE_FONT, '#ffffff', 'center', valueBadge, 14, 8, 0);
          cursor += vH + 6;
          var labelBadge = badgeSize([item.label], LABEL_FONT, 10, 6, 0);
          var lH = drawTextBlock(cx, cursor, [item.label], LABEL_FONT, '#ffffff', 'center', labelBadge, 10, 6, 0);
          cursor += lH + 6;
          if (item.perHour) {
            var phBadge = badgeSize([item.perHour], PERHOUR_FONT, 8, 5, 0);
            drawTextBlock(cx, cursor, [item.perHour], PERHOUR_FONT, 'rgba(175,210,242,.95)', 'center', phBadge, 8, 5, 0);
          }
        } else {
          ctx.font = VALUE_FONT;
          ctx.fillStyle = '#ffffff';
          ctx.fillText(item.value, cx, top + 74);

          ctx.font = LABEL_FONT;
          ctx.fillStyle = 'rgba(255,255,255,.55)';
          ctx.fillText(item.label, cx, top + 96);

          if (item.perHour) {
            ctx.font = PERHOUR_FONT;
            ctx.fillStyle = 'rgba(255,255,255,.4)';
            ctx.fillText(item.perHour, cx, top + 114);
          }
        }
      });
      ctx.textAlign = 'left';
    }

    // ===================== banner (moldura): ícones vetoriais em linha =====================
    // ícones outline simples desenhados com paths (sem depender de emoji),
    // pra bater com o template de referência: sprout/carboidrato, shaker/sódio,
    // raio/cafeína, gota/água, hexágono/nitrato.
    function drawIconSprout(cx, cy, size) {
      ctx.save();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
      ctx.lineJoin = 'round';
      var baseY = cy + size * 0.32;
      var stemTopY = baseY - size * 0.18;
      ctx.beginPath();
      ctx.moveTo(cx, baseY);
      ctx.lineTo(cx, stemTopY);
      ctx.stroke();
      [-90, -150, -30].forEach(function (deg) {
        var rad = deg * Math.PI / 180;
        var len = size * 0.42;
        var tipX = cx + Math.cos(rad) * len;
        var tipY = stemTopY + Math.sin(rad) * len;
        var midX = cx + Math.cos(rad) * len * 0.5;
        var midY = stemTopY + Math.sin(rad) * len * 0.5;
        var perpX = Math.cos(rad + Math.PI / 2) * size * 0.13;
        var perpY = Math.sin(rad + Math.PI / 2) * size * 0.13;
        ctx.beginPath();
        ctx.moveTo(cx, stemTopY);
        ctx.quadraticCurveTo(midX + perpX, midY + perpY, tipX, tipY);
        ctx.quadraticCurveTo(midX - perpX, midY - perpY, cx, stemTopY);
        ctx.stroke();
      });
      ctx.restore();
    }

    function drawIconSalt(cx, cy, size) {
      ctx.save();
      ctx.strokeStyle = '#ffffff';
      ctx.fillStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      var w = size * 0.6, h = size * 0.92;
      var top = cy - h / 2, bottom = cy + h / 2;
      ctx.beginPath();
      ctx.moveTo(cx - w * 0.3, top + h * 0.18);
      ctx.quadraticCurveTo(cx - w * 0.3, top, cx, top);
      ctx.quadraticCurveTo(cx + w * 0.3, top, cx + w * 0.3, top + h * 0.18);
      ctx.lineTo(cx + w / 2, bottom - h * 0.1);
      ctx.quadraticCurveTo(cx + w / 2, bottom, cx + w / 2 - h * 0.1, bottom);
      ctx.lineTo(cx - w / 2 + h * 0.1, bottom);
      ctx.quadraticCurveTo(cx - w / 2, bottom, cx - w / 2, bottom - h * 0.1);
      ctx.closePath();
      ctx.stroke();
      var dotR = 1.4;
      [[-0.12, 0.32], [0.12, 0.32], [-0.2, 0.46], [0, 0.46], [0.2, 0.46]].forEach(function (p) {
        ctx.beginPath();
        ctx.arc(cx + p[0] * w, top + p[1] * h, dotR, 0, Math.PI * 2);
        ctx.fill();
      });
      ctx.restore();
    }

    function drawIconBolt(cx, cy, size) {
      ctx.save();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      ctx.lineCap = 'round';
      var h = size, w = size * 0.6;
      ctx.beginPath();
      ctx.moveTo(cx + w * 0.12, cy - h / 2);
      ctx.lineTo(cx - w * 0.38, cy + h * 0.06);
      ctx.lineTo(cx - w * 0.02, cy + h * 0.06);
      ctx.lineTo(cx - w * 0.12, cy + h / 2);
      ctx.lineTo(cx + w * 0.38, cy - h * 0.08);
      ctx.lineTo(cx + w * 0.02, cy - h * 0.08);
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }

    function drawIconDrop(cx, cy, size) {
      ctx.save();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      var h = size, w = size * 0.8;
      ctx.beginPath();
      ctx.moveTo(cx, cy - h / 2);
      ctx.bezierCurveTo(cx + w / 2, cy - h * 0.02, cx + w / 2, cy + h * 0.42, cx, cy + h / 2);
      ctx.bezierCurveTo(cx - w / 2, cy + h * 0.42, cx - w / 2, cy - h * 0.02, cx, cy - h / 2);
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }

    function drawIconHex(cx, cy, size) {
      ctx.save();
      ctx.strokeStyle = '#ffffff';
      ctx.lineWidth = 2;
      ctx.lineJoin = 'round';
      var r = size / 2;
      ctx.beginPath();
      for (var i = 0; i < 6; i++) {
        var ang = (Math.PI / 180) * (60 * i - 90);
        var x = cx + r * Math.cos(ang);
        var y = cy + r * Math.sin(ang);
        if (i === 0) ctx.moveTo(x, y); else ctx.lineTo(x, y);
      }
      ctx.closePath();
      ctx.stroke();
      ctx.restore();
    }

    function drawBannerIcon(key, cx, cy, size) {
      if (key === 'cho') drawIconSprout(cx, cy, size);
      else if (key === 'na') drawIconSalt(cx, cy, size);
      else if (key === 'caf') drawIconBolt(cx, cy, size);
      else if (key === 'water') drawIconDrop(cx, cy, size);
      else if (key === 'nitrato') drawIconHex(cx, cy, size);
    }

    // mede o layout do banner (larguras reais de cada coluna + bloco da marca)
    // só pode rodar depois que a logo carregou, pra saber a proporção real
    // dela e não adivinhar a largura reservada pro bloco "FUELED BY / pace it".
    function layoutBanner() {
      var PAD_X = 44, PAD_Y = 38;
      var ICON_SIZE = 28;
      var COL_GAP = 34;
      var LOGO_H = 24;

      var colW = items.map(function (item) {
        var w = Math.max(measureW(VALUE_FONT, item.value), measureW(LABEL_FONT, item.label), ICON_SIZE);
        if (item.perHour) w = Math.max(w, measureW(PERHOUR_FONT, item.perHour));
        return w;
      });

      var fbW = measureW(FUELED_FONT, 'FUELED BY');
      var logoAspect = logoTmp ? (logoTmp.width / logoTmp.height) : 3.6;
      var logoW = LOGO_H * logoAspect;
      var brandW = Math.max(fbW, logoW);

      var colX = [];
      var cursor = PAD_X;
      colW.forEach(function (w) {
        colX.push(cursor);
        cursor += w + COL_GAP;
      });
      var brandX = cursor;
      var cardW = brandX + brandW + PAD_X;
      var totalH = PAD_Y * 2 + 118;

      return {
        PAD_X: PAD_X, PAD_Y: PAD_Y, ICON_SIZE: ICON_SIZE, COL_GAP: COL_GAP,
        colW: colW, colX: colX, brandX: brandX, LOGO_H: LOGO_H,
        CARD_W: cardW, TOTAL_H: totalH
      };
    }

    function drawBanner(L) {
      var top = L.PAD_Y;
      var iconCy = top + 14;

      items.forEach(function (item, i) {
        var cx = L.colX[i] + L.colW[i] / 2;
        drawBannerIcon(item.key, cx, iconCy, L.ICON_SIZE);

        ctx.textAlign = 'center';
        ctx.font = VALUE_FONT;
        ctx.fillStyle = '#ffffff';
        ctx.fillText(item.value, cx, top + 74);

        ctx.font = LABEL_FONT;
        ctx.fillStyle = 'rgba(255,255,255,.55)';
        ctx.fillText(item.label, cx, top + 96);

        if (item.perHour) {
          ctx.font = PERHOUR_FONT;
          ctx.fillStyle = 'rgba(255,255,255,.4)';
          ctx.fillText(item.perHour, cx, top + 114);
        }

        var dividerX = L.colX[i] + L.colW[i] + L.COL_GAP / 2;
        ctx.strokeStyle = 'rgba(255,255,255,.25)';
        ctx.lineWidth = 1;
        ctx.beginPath();
        ctx.moveTo(dividerX, top - 4);
        ctx.lineTo(dividerX, top + 122);
        ctx.stroke();
      });

      ctx.textAlign = 'left';
      ctx.font = FUELED_FONT;
      ctx.fillStyle = 'rgba(255,255,255,.55)';
      ctx.fillText('FUELED BY', L.brandX, top + 34);
      if (logoTmp) {
        var logoW = (logoTmp.width / logoTmp.height) * L.LOGO_H;
        ctx.drawImage(logoTmp, L.brandX, top + 44, logoW, L.LOGO_H);
      }
      ctx.textAlign = 'left';
    }

    function finish() {
      if (isBanner) {
        var L = layoutBanner();
        canvas = document.createElement('canvas');
        canvas.width = L.CARD_W;
        canvas.height = L.TOTAL_H;
        ctx = canvas.getContext('2d');
        drawBanner(L);
        if (callback) callback(canvas);
        return;
      }
      if (isTimeline) {
        drawTimeline(PAD_TOP);
        if (callback) callback(canvas);
        return;
      }
      var cursor = PAD_TOP;
      drawBrandHeader(cursor, logoTmp);
      cursor += BRAND_HEADER_H + GAP_BRAND_NEXT;
      if (hasSchedule) {
        drawTimeline(cursor);
        cursor += timelineBlockH + GAP_TIMELINE_STATS;
      }
      drawStatsRow(cursor);
      if (callback) callback(canvas);
    }

    var logoTmp = null;
    var settled = false;

    // carrega a logo + as fotinhos dos produtos usados no plano de consumo
    // antes de desenhar (o canvas precisa das imagens já prontas).
    var scheduleImages = {};
    var thumbUrls = [];
    if (hasSchedule) {
      schedule.forEach(function (entry) {
        if (entry.img && thumbUrls.indexOf(entry.img) === -1) thumbUrls.push(entry.img);
      });
    }

    // o overlay "timeline" não mostra a marca, então não precisa carregar a logo.
    var needsLogo = !isTimeline;
    var assetsPending = (needsLogo ? 1 : 0) + thumbUrls.length;
    var assetsLoaded = 0;

    function settle() {
      if (settled) return;
      settled = true;
      finish();
    }

    function assetDone() {
      assetsLoaded++;
      if (assetsLoaded >= assetsPending) settle();
    }

    if (needsLogo) {
      var logo = new Image();
      logo.crossOrigin = 'anonymous';
      logo.onload = function () {
        logoTmp = logo;
        assetDone();
      };
      logo.onerror = function () {
        assetDone();
      };
      logo.src = data.logoUrl || LOGO_URL;
    } else if (assetsPending === 0) {
      setTimeout(settle, 0);
    }

    thumbUrls.forEach(function (url) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        scheduleImages[url] = img;
        assetDone();
      };
      img.onerror = function () {
        scheduleImages[url] = null;
        assetDone();
      };
      img.src = url;
    });

    // fallback de segurança caso alguma imagem demore/trave
    setTimeout(function () {
      if (!settled) {
        settle();
      }
    }, 3000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-lcf-root]');
    roots.forEach ? roots.forEach(init) : Array.prototype.forEach.call(roots, init);
  });
})();
